import getLogger from '../debuggers/logger'

const logger = getLogger('iframe')

/**
 * To calculate the height of this document.
 */
const documentHeight = () => {
  return Math.max(
    document.documentElement.clientHeight,
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight
  )
}

/**
 * To check if this application is being loaded inside an iframe or directly into the
 * browser window.
 *
 * Credits:
 * https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t?answertab=active#tab-top
 */
export const inIframe = () => {
  return window.self !== window.top
}

/**
 * This function creates an observer that runs on every mutation of the document height.
 * When the height changes, we send a message to our parent (MP) to perform an iframe
 * resize.
 */
export const observerResizeIframe = (
  url,
  { action = 'resizeIframe', attributes = true, childList = false, subtree = true } = {}
) => {
  const bodyTarget = document.documentElement
  // Options for the observer (which mutations to observe).
  const config = {
    attributes,
    childList,
    subtree
  }
  let bodySize = documentHeight()

  // Callback function to execute when mutations are observed.
  const bodyCallback = mutationsList => {
    // Use traditional 'for loops' for IE 11.
    for (const mutation of mutationsList) {
      if (
        (!config.childList && mutation.type !== 'attributes') ||
        (config.childList && ['attributes', 'childList'].indexOf(mutation.type) === -1)
      ) {
        break
      }

      const updatedBodySize = documentHeight()

      if (updatedBodySize !== bodySize) {
        window.parent?.postMessage({ action, value: updatedBodySize }, url)
      }

      bodySize = updatedBodySize !== bodySize ? updatedBodySize : bodySize
    }
  }

  try {
    // Create an observer instance linked to the callback function.
    const bodyObserver = new MutationObserver(bodyCallback)

    // Start observing the target node for configured mutations.
    bodyObserver.observe(bodyTarget, config)
  } catch (error) {
    logger.error('Error while observing the iframe resize changes. ', error)
  }
}
